import React from 'react';
import { AuthContext } from './auth';
import { ErrorContext } from './ErrorProvider';

export function withAuxDataContext<T>(Component: any) {
	return (props: Omit<T, 'errorData' | 'authData'>) => (
		<ErrorContext.Consumer>
			{(errorData) => (
				<AuthContext.Consumer>
					{(authData) => (
						<Component {...props} authData={authData} errorData={errorData} />
					)}
				</AuthContext.Consumer>
			)}
		</ErrorContext.Consumer>
	);
}
